import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { DashboardHttpService } from '../http/dashboard-http.service';
import { AccountService } from '../services/account.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardHttpResolverService implements Resolve<any> {
    constructor(private dashboardHttpService: DashboardHttpService, private accountService: AccountService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.dashboardHttpService.getDashboardReport();
    }
}
